// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import type { Props } from "app/components/TimelineCard/TimelineCard";
import ShortComment from "app/components/ShortComment/ShortComment";

import "./TextTimelineCard.scss";

@observer
export default class TextTimelineCard extends React.Component<Props> {
    
    handleReadMore = () => {
        this.props.onExpand();
    }

    get length(): number {
        return AppearanceStore.timelineContentLength;
    }

    render() {
        const item = this.props.item;
        const comment = item.comment;
        const classes = ["TextTimelineCard", "clearfix"];
        if (comment.length <= 20) classes.push("TextTimelineCard--big");

        return (
            <div className={classes.join(" ")}>
                <div className="TextTimelineCard__comment">
                    <ShortComment
                        itemId={item.rowid}
                        comment={comment}
                        length={this.length}
                        key={item.rowid}
                        onReadMore={this.handleReadMore}
                    />
                </div>
            </div>
        );
        
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/TextTimelineCard/TextTimelineCard.js